import type { Idioma } from '../../i18n/index.js';

const es = {
  titulo: 'Mis estudios',
  volverCuenta: 'Volver a Mi cuenta',
  subidos: 'Estudios subidos',
  admin: 'Estudios enviados',
  permisos: 'Acceso de editores',
  cargando: 'Cargando…',
  actualizar: 'Actualizar',
  error: 'No se pudo completar la operación. Actualiza e inténtalo de nuevo.',
  prohibido: 'Tu cuenta no tiene permiso para enviar estudios. Puedes consultar tu historial.',
  limite: 'Has alcanzado el límite de estudios pendientes de aprobación.',
  enviar: 'Enviar estudio',
  tituloCampo: 'Título',
  editor: 'Entidad editora',
  url: 'Enlace público del estudio',
  pdf: 'Archivo PDF',
  autorizacion: 'Represento a la entidad editora y autorizo el procesamiento de este PDF y la publicación de su ficha y citas en Athena.',
  privado: 'El envío permanece privado hasta su aprobación e incorporación. Enviar no garantiza su publicación ni un plazo.',
  vacio: 'Todavía no hay estudios enviados.',
  pendiente: 'Pendiente de aprobación',
  aprobado: 'Aprobado',
  rechazado: 'Rechazado',
  retirado: 'Retirado',
  en_cola: 'Aprobado · en cola',
  colaProcesamiento: 'En cola de procesamiento',
  procesando: 'Procesando',
  revision_tecnica: 'Revisión técnica',
  errorTecnico: 'Error técnico de procesamiento',
  incorporado: 'Incorporado',
  cargado: 'Procesado · pendiente de publicación',
  verPdf: 'Abrir PDF privado',
  pdfListo: 'PDF preparado: abrir en una pestaña nueva',
  duplicado: 'Este PDF ya está presente o aprobado. Comprueba el duplicado antes de incorporar.',
  ficha: 'Ver ficha pública',
  retirar: 'Retirar envío',
  aprobar: 'Aprobar incorporación',
  rechazar: 'Rechazar',
  motivo: 'Motivo del rechazo',
  correo: 'Correo de la cuenta existente',
  nota: 'Nota de comprobación o motivo',
  conceder: 'Conceder acceso',
  revocar: 'Revocar acceso',
  activo: 'Habilitado',
  revocado: 'Revocado',
  invalido: 'Selecciona un PDF dentro del límite de tamaño.',
  guardado: 'Operación guardada.',
  sinAcceso: 'No se pudo cargar el panel. Comprueba tu sesión y actualiza.',
};
const en: typeof es = {
  titulo: 'My studies',
  volverCuenta: 'Back to My account',
  subidos: 'Uploaded studies',
  admin: 'Submitted studies',
  permisos: 'Publisher access',
  cargando: 'Loading…',
  actualizar: 'Refresh',
  error: 'The operation could not be completed. Refresh and try again.',
  prohibido: 'Your account cannot submit studies. You can still view your history.',
  limite: 'You have reached the limit of studies awaiting approval.',
  enviar: 'Submit study',
  tituloCampo: 'Title',
  editor: 'Publishing organisation',
  url: 'Public study link',
  pdf: 'PDF file',
  autorizacion: 'I represent the publishing organisation and authorise processing this PDF and publishing its study page and quotations in Athena.',
  privado: 'Submissions remain private until approval and incorporation. Submission does not guarantee publication or a deadline.',
  vacio: 'No studies submitted yet.',
  pendiente: 'Awaiting approval',
  aprobado: 'Approved',
  rechazado: 'Rejected',
  retirado: 'Withdrawn',
  en_cola: 'Approved · queued',
  colaProcesamiento: 'Queued for processing',
  procesando: 'Processing',
  revision_tecnica: 'Technical review',
  errorTecnico: 'Technical processing error',
  incorporado: 'Incorporated',
  cargado: 'Processed · awaiting publication',
  verPdf: 'Open private PDF',
  pdfListo: 'PDF ready: open in a new tab',
  duplicado: 'This PDF is already present or approved. Check the duplicate before incorporating it.',
  ficha: 'View public study page',
  retirar: 'Withdraw submission',
  aprobar: 'Approve incorporation',
  rechazar: 'Reject',
  motivo: 'Reason for rejection',
  correo: 'Existing account email',
  nota: 'Verification note or reason',
  conceder: 'Grant access',
  revocar: 'Revoke access',
  activo: 'Enabled',
  revocado: 'Revoked',
  invalido: 'Select a PDF within the file size limit.',
  guardado: 'Operation saved.',
  sinAcceso: 'The panel could not be loaded. Check your session and refresh.',
};
export const textosEstudios = (idioma: Idioma) => (idioma === 'en' ? en : es);
